(function( $ ) {
	function toggleAriaExpanded($elm) {
		$elm.attr('aria-expanded', function (i, attr) {
			return attr == 'true' ? 'false' : 'true';
		});
	}

	// Search Toggle
	$('.search-toggle', '#masthead').on('click', function(){
		$('#site-navigation').removeClass('toggled-on').find('button.menu-toggle').attr('aria-expanded', false);
		toggleAriaExpanded($(this));
		if($(this).attr('aria-expanded') == 'true') {
			$('html').addClass('menu-expanded');
			$('#search-menu input[type="search"]').focus();
		} else {
			$('html').removeClass('menu-expanded');
		}
	});

	$('#search-menu .close-button').on('click', function(){
		$('.search-toggle', '#masthead').trigger('click');
	});


	// Blur
	$('ul#top-menu > li:last-child > a').on('blur', function(){
		$('#site-nav-toggle').attr('aria-expanded', false).focus();
		$('#site-navigation').removeClass('toggled-on');
		$('html').removeClass('menu-expanded');
	});

	// Toggle Section
	$('#section-toggle').on('click', function(){
		toggleAriaExpanded($(this));
	});
	

	// Filter Toggle
	$('.filter-toggle').on('click', function(){
		toggleAriaExpanded($(this));
	});

	/*---------------------
		Table Scrolling
		--------------------*/
	$('.scroll-right').on('click', function() {
		var elWidth = $(this).siblings('table').width();

		$(this).parent('.table-container').animate({ // smooth scroll
			scrollLeft: elWidth
		}, 300, 'swing')
	});

	$('.scroll-left').on('click', function() {
		$(this).parent('.table-container').animate({ // smooth scroll
			scrollLeft: 0
		}, 300, 'swing')
	});

	/*---------------------
		Inject Video Block Html (for use with poster image)
		--------------------*/
	$('a.poster-image').on('click', function(e) {
		e.preventDefault();
		var target = $(this).attr("data-dartisans-videoid");
		var videoId = target.split('-')[0];
		var html;
		if($(this).hasClass("youtube")) {
			html = `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
		} else {
			html = `<iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&autopause=0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
		}
		$(`#video-${target}`).html(html);
		$(this).fadeOut("fast", function(){
			$(this).remove();
		});
	});

	/*---------------------
		Toggle Menu JS accessibly
		optionally add class hideonfocusout
		target must be next sibling in the dom for hideonfocusout
		help from https://stackoverflow.com/questions/152975/how-do-i-detect-a-click-outside-an-element
		--see zzzzBov's answer that covers this for accessibility thoroughly
	--------------------*/	
	$('.hastogglemenu button.toggler').on('click', function() {
		toggleAriaExpanded($(this));
	});
	$('.hastogglemenu button.toggler.hideonfocusout').next().on({
		focusout: function() {
			$(this).data('timer', setTimeout(function() {
				toggleAriaExpanded($(this).prev());
			}.bind(this), 0));
		},
		focusin: function() {
			clearTimeout($(this).data('timer'));
		},
		//escape key closes
		keydown: function(e) { 
			if(e.which === 27) {
				toggleAriaExpanded($(this).prev());
				e.preventDefault();
			}
		}
	});
	$('.hastogglemenu button.toggler.hideonfocusout').on({
		focusout: function() {
			$(this).next().data('timer', setTimeout(function() {
				toggleAriaExpanded($(this));
			}.bind(this), 0));
		},
		focusin: function() {
			clearTimeout($(this).next().data('timer'));
		}
	});

	
	/*---------------------
		Testimonials
		--------------------*/
	$('section.testimonials .text').slick();

	//manually move arrows because slicks appendarrows setting breaks with multiple because of generic selector
	$('section.testimonials .text .slick-arrow').each(function(){
		$(this).parent().parent().children('.arrows').append($(this));
	});

	/*---------------------
		Tabbed Content
		--the ugliest block of spaghetti this side of the mississipi
		--------------------*/
	$('button.tabbutton').on('click', function(){
		$(`#${this.id.substring(0, this.id.length - 7)}`).trigger('click');
	});
	$('a.tabbutton').on('click', function(e){
		e.preventDefault(); 
		var $tabList = $(this).parent().parent();
		var lastTab = $tabList.attr('data-da-visible-tab');
		var lastLink = '#'+$(lastTab).attr('aria-labelledby');
		var thisButton = `#${this.id}-button`;
		var target = $(this).attr('href');
		$(lastLink).attr('aria-expanded', 'false');
		$(lastLink).parent().removeClass('active');
		toggleAriaExpanded($(thisButton));
		$(this).attr('aria-expanded', 'true');
		$(this).parent().addClass('active');
		$tabList.attr('data-da-visible-tab', `${target}`);
		if(lastTab != target) {
			$(target).addClass('activetab');
			$(lastTab).removeClass('activetab');
		}
	});

	/*---------------------
		listing filters
		//this should support as many filters as you would ever need
		--------------------*/

	function updateQueryString($selectelm) {
		var filter = $selectelm.parent().attr('data-da-filter-var');
		var query = $selectelm.val();
		var filterlink = $('a.listingfilter');
		var href = filterlink.attr('href');
		var queries = href.indexOf( '?' ) === -1 ? [] :
			href.slice(href.indexOf('?')+1).split('&');
		var filters = $.map(queries, function(qry){
			return qry.slice(0, qry.indexOf('='));
		});

		var queryIndex = $.inArray(filter, filters);

		query = $selectelm.val() === '0' ? 
			'' 
			:
			filter+'='+$selectelm.val();
		
		queryIndex === -1 ? queries.push(query) : 
			query === '' ?
				queries.splice(queryIndex, 1)
				:
				queries.splice(queryIndex, 1, query);

		return queries.length > 0 ? '?'+queries.join('&') : '';

	}

	function getQueryString() {
		var queryString = window.location.href;
		queryString = queryString.indexOf( '?' ) === -1 ?
			''
			:
			queryString.slice(queryString.indexOf( '?' ));

		return queryString;
	}

	function buildHREF(href, queryString) {
		return (
				href.indexOf('?') === -1 ?
					href
					:
					href.slice(0, href.indexOf('?'))
				) + queryString;
	}
	
	$('.listing-filters select').on('change', function() {

		var filterlink = $('a.listingfilter');

		var href = filterlink.attr('href');

		var queryString = updateQueryString($(this));

		href = buildHREF(href, queryString);

		filterlink.attr('href', href);
		 
	});

	//update on page load
	$('a.listingfilter').attr('href', window.location);

	/*---------------------
		scroll to gravityform confirmation if not visible
		--------------------*/
	if($('#gform_confirmation_wrapper_1').length && $('#gform_confirmation_wrapper_1').offset().top > $(window).height()) {
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
		$.scrollTo('#gform_confirmation_wrapper_1');
	}


})( jQuery );
